<template>
  <el-col>
      <w-timeline-chart :active="active" @clickChart="onClickChart"/>
      <component v-for="chartView in templateCharts" :key="chartView.templateId" :is="chartView.componentName" :active="active" :chartVisible="true" :agentData="agentData" @clickChart="onClickChart" @clickAddButton="onClickAddButton"/>
  </el-col>
</template>

<script>
import { mapGetters } from 'vuex';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import isEmpty from 'lodash/isEmpty';

import AnalysisMixin from '@/mixins/performance/analysis';
import ChartAPI from '@/api/performance/analysis/analysis-chart';
import perfCommonApi from '@/api/performance/common';

import WTimelineChart from '@/views/performance/node/analysis/components/TimelineChart';
import WServiceResponsetimeAnalysisChart from './components/chart/ServiceResponsetimeAnalysisChart';
import WAgentResponsetimeAnalysisChart from './components/chart/AgentResponsetimeAnalysisChart';

export default {
  name: 'WPerformanceE2eAnalysisChart',
  components: {
    WTimelineChart,
    WServiceResponsetimeAnalysisChart,
    WAgentResponsetimeAnalysisChart,
  },
  mixins: [AnalysisMixin],
  data() {
    return {
      agentData: [],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      immediate: true,
      handler(node) {
        if (!this.active || isEmpty(node)) {
          return;
        }

        this.$store.dispatch('setPlotLineDatetime', null);
        this.loadData();
      },
    },
  },
  methods: {
    /**
     * E2E에이전트 리스트를 가져와 대표 에이전트를 정한다.
     * @return {[type]} [description]
     * @author jda
     */
    loadE2EAgentListByRscKey() {
      ChartAPI.getE2EAgentListByRscKey({ rscKey: this.selectedNode.rscKey }).then((response) => {
        if (response.data.success) {
          this.agentData = response.data.data;
        }
      });
    },
    /**
     * 1. 사용자 별 분석 그래프 설정 데이터를 가져와서 표현할 자원의 컴포넌트를 설정한다.
     * 2. E2E에이전트 리스트를 가져와 대표 에이전트를 정한다.
     * @author jda
     * @return {[type]} [description]
     */
    loadData() {
      const params = {
        managetypeId: this.selectedNode.obj.objManagetypeId || 'E2E',
      };
      perfCommonApi.getPerfChartTypeByMgr(params).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          const templateCharts = [];

          result.forEach((record) => {
            templateCharts.push({
              componentName: `W${upperFirst(camelCase(record.chartTypeId))}AnalysisChart`,
              templateId: record.chartTypeId,
            });
          });
          this.templateCharts = templateCharts;
        }
        this.loadE2EAgentListByRscKey();
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/e2e/PerformanceE2eAnalysisChart.vue